import { render, staticRenderFns } from "./layout-category-page.vue?vue&type=template&id=d48ca3a2&scoped=true&"
import script from "./layout-category-page.vue?vue&type=script&lang=js&"
export * from "./layout-category-page.vue?vue&type=script&lang=js&"
import style0 from "./layout-category-page.vue?vue&type=style&index=0&id=d48ca3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48ca3a2",
  null
  
)

export default component.exports